import { ButtonIcon, Tooltip, TrashIcon } from 'canoe';
import React from 'react';

import { TooltipBodyWithShortcuts } from 'craft/components/TooltipBodyWithShortcuts';

export const DeleteButton = ({
  tooltipPlacement,
  disabled,
  onClick,
}: {
  tooltipPlacement: 'top' | 'bottom';
  disabled: boolean;
  onClick: VoidFunction;
}) => {
  return (
    <Tooltip
      placement={tooltipPlacement}
      offset="xxs"
      content={<TooltipBodyWithShortcuts content="Delete" shortcuts={['Delete']} />}
      disabled={disabled}
    >
      <ButtonIcon
        size="small"
        icon={TrashIcon}
        onClick={onClick}
        disabled={disabled}
        radius="small"
        color="white"
      />
    </Tooltip>
  );
};
